'use strict';

const PHONE_CONFIG = {
    rules: {
        '+91': { length: 10, firstDigits: [6, 7, 8, 9] },
        '+1': { length: 10, firstDigits: [2, 3, 4, 5, 6, 7, 8, 9] },
        '+44': { length: 10, firstDigits: [7] },
        '+65': { length: 8, firstDigits: [8, 9] },
        '+971': { length: 9, firstDigits: [5] },
        '+61': { length: 9, firstDigits: [4] },
        '+33': { length: 9, firstDigits: [6, 7] },
        '+49': { length: 10, firstDigits: [1] },
        '+39': { length: 10, firstDigits: [3] },
        '+34': { length: 9, firstDigits: [6, 7] },
        '+32': { length: 9, firstDigits: [4] },
        '+43': { length: 10, firstDigits: [6] },
        '+385': { length: 9, firstDigits: [9] },
        '+357': { length: 8, firstDigits: [9] },
        '+372': { length: 7, firstDigits: [5] },
        '+358': { length: 9, firstDigits: [4, 5] },
        '+30': { length: 10, firstDigits: [6] },
        '+353': { length: 9, firstDigits: [8] },
        '+371': { length: 8, firstDigits: [2] },
        '+370': { length: 8, firstDigits: [6] },
        '+352': { length: 9, firstDigits: [6] },
        '+356': { length: 8, firstDigits: [7, 9] },
        '+31': { length: 9, firstDigits: [6] },
        '+351': { length: 9, firstDigits: [9] },
        '+421': { length: 9, firstDigits: [9] },
        '+386': { length: 8, firstDigits: [3, 4, 5, 6, 7] }
    },
    defaultLength: 10
};

const SELECTORS = {
    modal: '#downloadCatalog',
    form: '.download-catalog-form',
    submitBtn: '.download-catalog-submit',
    fullName: '#dcfullName',
    phone: '#dcphone',
    email: '#dcemail',
    dropdown: '#download-catalog-dropdown',
    countryOption: '.py-option-value.download-catalog-country-options',
    modalBtn: '.download-catalog-btn-modal',
    pdfLink: '.pdf-download-catalog',
    crossIcon: '.py-cross-right',
    dcCross: '.py-cross-right.dc-cross'
};

const PATTERNS = {
    email: /^(?!.*\.\.)[^\s@]+@[^\s@]+\.[^\s@]+$/,
    fullName: /^(?! )[A-Za-z]+(?: [A-Za-z]+)*$/
};

// Document ready initialization
$(function () {
    $(SELECTORS.modalBtn).removeAttr('data-toggle').removeAttr('data-target');

    $(document).on('click', SELECTORS.modalBtn, function (e) {
        e.preventDefault();
        const pdfFileUrl = $(this).data('pdf-file-name');
        const collectionName = $(this).data('collection-name');

        $('.pdf-file-url').attr('href', pdfFileUrl);
        $('.collectionName').val(collectionName);

        $(SELECTORS.modal).modal('show');
    });
});

/**
 * Gets phone validation rules for a given ISD code
 * @param {string} isdCode - Country ISD code
 * @returns {Object} Phone validation rules
 */
function getPhoneRules(isdCode) {
    return PHONE_CONFIG.rules[isdCode] || {
        length: PHONE_CONFIG.defaultLength,
        firstDigits: []
    };
}

/**
 * Validates all form fields and toggles submit button
 */
function toggleSubmitButton() {
    const $submitBtn = $(SELECTORS.submitBtn);

    const fullNameValue = $(SELECTORS.fullName).val().trim();
    const phoneValue = $(SELECTORS.phone).val().trim();
    const emailValue = $(SELECTORS.email).val().trim();
    const requiredPhoneLength = parseInt($(SELECTORS.phone).attr('maxlength'), 10) || PHONE_CONFIG.defaultLength;

    const isValid = fullNameValue.length > 0
        && phoneValue.length === requiredPhoneLength
        && /^[0-9]+$/.test(phoneValue)
        && PATTERNS.email.test(emailValue);

    $submitBtn.prop('disabled', !isValid);
}

/**
 * Updates phone input attributes based on selected country
 * @param {string} isdCode - Selected country's ISD code
 */
function updatePhoneValidation(isdCode) {
    const $phoneInput = $(SELECTORS.phone);
    const rules = getPhoneRules(isdCode);

    $phoneInput.attr({
        maxlength: rules.length,
        minlength: rules.length
    }).val('');
}

/**
 * Validates phone number input based on country rules
 * @param {string} value - Phone number value
 * @param {string} isdCode - Country ISD code
 * @returns {string} Validated phone number
 */
function validatePhoneInput(value, isdCode) {
    const rules = getPhoneRules(isdCode);
    let sanitized = value.replace(/\D/g, '');

    if (sanitized.length > 0 && rules.firstDigits.length > 0) {
        const firstDigit = parseInt(sanitized.charAt(0), 10);
        if (!rules.firstDigits.includes(firstDigit)) {
            return '';
        }
    }

    return sanitized.length > rules.length
        ? sanitized.substring(0, rules.length)
        : sanitized;
}

/**
 * Toggles cross icon visibility based on input value
 * @param {jQuery} $input - Input element
 */
function toggleCrossIcon($input) {
    const $icon = $input.siblings(SELECTORS.crossIcon);
    $icon.toggleClass('d-none', !$input.val().trim().length);
}

/**
 * Resets modal to default state
 */
function resetModalState() {
    const $modal = $(SELECTORS.modal);
    const $form = $modal.find(SELECTORS.form);

    $form[0].reset();
    $form.find(SELECTORS.crossIcon).addClass('d-none');

    $(SELECTORS.dropdown).val('+91').attr({ 'country-value': 'India', 'country-code': 'IN' });
    $('.selected-flag').attr('src', $('#hiddenFlag').val());
    $(SELECTORS.countryOption).removeClass('selected')
        .filter('[data-value="IN"]').addClass('selected');

    $(SELECTORS.phone).attr({ maxlength: 10, minlength: 10 }).removeClass('has-value');
    $(SELECTORS.fullName).removeClass('has-value');
    $(SELECTORS.email).removeClass('has-value');
    $(SELECTORS.submitBtn).prop('disabled', true);

    $modal.removeAttr('style');

    setTimeout(() => {
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open').css('padding-right', '');
        $modal.removeData('bs.modal');
    }, 150);
}

// Phone input validation
$(SELECTORS.phone).on('input', function () {
    const $this = $(this);
    const isdCode = $(SELECTORS.dropdown).val();
    const validatedValue = validatePhoneInput($this.val(), isdCode);

    $this.val(validatedValue);
    toggleCrossIcon($this);
    toggleSubmitButton();
});

// Country selection handler
$(document).on('click', SELECTORS.countryOption, function () {
    const $this = $(this);
    const $parent = $this.closest('.py-custom-select-div');
    const $dropdownInput = $parent.find(SELECTORS.dropdown);
    const $flagLabel = $parent.find('.py-custom-select-label img');

    const countryName = $this.data('country-name');
    const countryCode = $this.data('value');
    const isdCode = $this.data('isd-code');
    const flagSrc = $this.find('img').attr('src');

    $dropdownInput.val(isdCode)
        .attr({ 'country-value': countryName, 'country-code': countryCode })
        .trigger('change');

    $flagLabel.attr({ src: flagSrc, alt: `${countryName} flag` });

    if (!$flagLabel.attr('id')) $flagLabel.attr('id', 'selectedFlag');
    if (!$flagLabel.hasClass('selected-flag')) $flagLabel.addClass('selected-flag');

    $this.addClass('selected').siblings().removeClass('selected');
    $parent.find('.py-option-values').removeClass('show');
    $parent.find('.py-dropdown-icon').removeClass('rotate');

    updatePhoneValidation(isdCode);
    toggleSubmitButton();
});

$(SELECTORS.modal).on('hidden.bs.modal', resetModalState);

// Full name input validation
$(SELECTORS.fullName).on('input', function () {
    const $this = $(this);
    let value = $this.val();

    if (!PATTERNS.fullName.test(value)) {
        value = value.replace(/[^A-Za-z ]/g, '')
            .replace(/^\s+/, '')
            .replace(/\s{2,}/g, ' ');
        $this.val(value);
    }

    toggleCrossIcon($this);
    toggleSubmitButton();
});

// Email input validation
$(SELECTORS.email).on('input', function () {
    const $this = $(this);
    const value = $this.val()
        .replace(/[^\w@.-]/g, '') // remove invalid chars
        .replace(/\.{2,}/g, '.');

    $this.val(value);
    toggleCrossIcon($this);
    toggleSubmitButton();
});

$(SELECTORS.dropdown).on('change', toggleSubmitButton);
$(SELECTORS.dcCross).on('click', () => {
    $(SELECTORS.submitBtn).prop('disabled', true);
});

// Form submission
$(SELECTORS.form).on('submit', function (e) {
    e.preventDefault();

    const $form = $(this);
    const url = $(SELECTORS.submitBtn).data('action');
    const formData = $form.serialize();
    $.spinner().start();
    $.ajax({
        type: 'POST',
        url: url,
        data: formData,
        success: (response) => {
            if (response.success) {
                $('.pdf-file-url')[0].click();
                $(SELECTORS.modal).modal('hide');
                $('body').trigger('successToast', response.message);
            } else {
                $(SELECTORS.modal).modal('hide');
                $('body').trigger('failureToast', response.message || 'Something went wrong. Please try again later.');
            }
            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
});
